import type { Action } from 'state/actions';
import { addOrReplaceKey, patchKey, removeKey } from 'state/utils/collection';

import type { AdvisoryUiStateMap } from './advisoryUi.model';
import { initialAdvisoryUiState } from './advisoryUi.model';

export function advisoryUiReducer(state: AdvisoryUiStateMap = {}, action: Action): AdvisoryUiStateMap {
  switch (action.type) {
    case 'QUOTE_REQUESTED':
    case 'PREVIOUS_QUOTE_LOADED':
      return addOrReplaceKey(state, action.tabId, initialAdvisoryUiState);

    case 'BASKET_OPTIMIZER_ACCORDION_TOGGLED':
      return patchKey(state, action.tabId, previousState => {
        return {
          isBasketOptimizerAccordionOpened: !previousState.isBasketOptimizerAccordionOpened,
        };
      });

    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);

    case 'QUOTE_STALE':
      if (!action.hasFormChanged || (action.workspace !== 'static' && action.workspace !== 'dynamic')) {
        return state;
      }
      return removeKey(state, action.tabId);

    case 'QUOTE_REMOVED':
      if (action.workspace !== 'static' && action.workspace !== 'dynamic') {
        return state;
      }
      return removeKey(state, action.tabId);

    default:
      return state;
  }
}
